import styled from '@emotion/styled';

import CirclesLogoBlack from '../../assets/circlesLogoBlack.svg';
import CirclesLogoWhite from '../../assets/circlesLogoWhite.svg';
import { getColor } from './UICommon';
import { TabletWidth } from '../../global.style';

const LogoWithNameWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const Logo = styled.img`
  margin-right: 6px;
  height: 24px;

  @media (max-width: ${TabletWidth}px) {
    height: 18px;
  }
`;

const LogoName = styled.span<{ colorVariant: LogoColorVariant }>`
  font-family: Poppins;
  font-size: 28px;
  font-weight: 500;
  line-height: 24px;
  color: ${(props) => getColor(props.colorVariant === 'black' ? 'GRAY_80' : 'WHITE')};

  @media (max-width: ${TabletWidth}px) {
    font-size: 21px;
  }
`;

export type LogoColorVariant = 'black' | 'white';

interface LogoWithNameProps {
  colorVariant?: LogoColorVariant;
}

export const LogoWithName: React.FC<LogoWithNameProps> = ({ colorVariant = 'black' }) => {
  return (
    <LogoWithNameWrapper>
      <Logo src={colorVariant === 'black' ? CirclesLogoBlack : CirclesLogoWhite} alt="" />
      <LogoName colorVariant={colorVariant}>circles</LogoName>
    </LogoWithNameWrapper>
  );
};
